import { cn } from '@/shared/lib/cn';
import type { ReactNode } from 'react';

/**
 * Full-width page header bar, distilled from the v1 `vision-lab-platform`
 * `EditorShell` header region: a bordered, horizontally-padded row with a `start`
 * slot on the left and an optional right-aligned `actions` slot (pushed over with
 * `ml-auto`, matching the shell's action host). Unlike the v1 shell it carries no
 * portal hosts or media chrome — it's just the header, for full-page, sidebar-less
 * views (e.g. the standalone asset detail) that want the editor look without the
 * editor machinery.
 */
export function EditorHeader({
  start,
  actions,
  className,
}: {
  start: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        'sticky top-0 z-10 flex shrink-0 items-center gap-2 border-b bg-background px-3 py-2 sm:gap-4 sm:px-6',
        className,
      )}
    >
      {start}
      {actions ? (
        <div className="ml-auto flex shrink-0 items-center gap-2 sm:gap-3">{actions}</div>
      ) : null}
    </header>
  );
}
